import { useLocation, Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectuserInfo } from 'hooks/userInfo'
import { useEffect } from 'react'
// import { useEffect } from 'react'

/**
 * 페이지 권한 체크
 * @param param0
 * @returns
 */
const RequireAuth = ({ allowedRoles }: any) => {
	const userInfo = useSelector(selectuserInfo)
	const location = useLocation()

	useEffect(() => {
		// console.log('-------------------------')
		// console.log('사용자 정보:', userInfo)
		// console.log('허용된 권한:', allowedRoles)
		// console.log('사용자 권한:', userInfo?.roles)
		// console.log('-------------------------')

		const hasPermission = userInfo?.roles?.find((role: any) =>
			allowedRoles?.includes(role.id)
		)
		// console.log('권한 체크 결과:', hasPermission)
	}, [userInfo, allowedRoles])

	// 사용자의 roles 중에서 allowedRoles에 포함된 권한이 있는지 확인
	const hasAllowedRole = userInfo?.roles?.some((role: any) =>
		allowedRoles?.includes(role.id)
	)

	// 로그인되어 있지 않은 경우
	if (!userInfo?.roles) {
		return (
			<Navigate
				to="/"
				state={{ from: location }}
				replace
			/>
		)
	}

	// 허용된 권한이 있는 경우
	if (hasAllowedRole) {
		return <Outlet />
	}

	// 로그인은 되어 있지만 권한이 없는 경우
	return (
		<Navigate
			to="/unauthorized"
			state={{ from: location }}
			replace
		/>
	)
}

export default RequireAuth
